import initState from "./initState";

export function clearQuestionsState({ setState }) {
  setState(initState());
}

function compareQuestionArrayAndReplace(state) {
  var present = state.presentQuestionsSelected.filter(
    (i) => state.presentQuestionsSelectedTemp.indexOf(i) !== -1
  );
  state.presentQuestionsSelectedTemp = [];
  state.presentQuestionsSelectedTemp = present;

  //second
  var absent = state.absentQuestionsSelected.filter(
    (i) => state.absentQuestionsSelectedTemp.indexOf(i) !== -1
  );
  state.absentQuestionsSelectedTemp = [];
  state.absentQuestionsSelectedTemp = absent;

  //third
  var unKnowAnswer = state.unknownQuestionsSelected.filter(
    (i) => state.unknownQuestionsSelectedTemp.indexOf(i) !== -1
  );
  state.unknownQuestionsSelectedTemp = [];
  state.unknownQuestionsSelectedTemp = unKnowAnswer;
}

export function addAnswers({ reqData, state }) {
  var elementPos = state.answersArray
    .map(function (x) {
      return x.QuestionOrder;
    })
    .indexOf(reqData.QuestionOrder);
  if (elementPos !== -1) {
    state.answersArray.splice(elementPos, 1);
  }
  state.answersArray.push(reqData);
}

export function addPresentQuestion({ item, state, setState }) {
  state.orderIdArray.push(state.Questions.order);
  //before adding check if its there already, if its there remove old one
  var presentTemp = state.presentQuestionsSelectedTemp.indexOf(item.id);
  if (presentTemp > -1) {
    state.presentQuestionsSelectedTemp.splice(presentTemp, 1);
  }
  //check other options if this question is saved
  var absentTemp = state.absentQuestionsSelectedTemp.indexOf(item.id);
  if (absentTemp > -1) {
    state.absentQuestionsSelectedTemp.splice(absentTemp, 1);
  }

  var unKnownTemp = state.unknownQuestionsSelectedTemp.indexOf(item.id);
  if (unKnownTemp > -1) {
    state.unknownQuestionsSelectedTemp.splice(unKnownTemp, 1);
  }
  if (presentTemp === -1) {
    compareQuestionArrayAndReplace(state);
  }

  state.presentQuestionsSelected.push(item.id);
  state.presentQuestionsSelectedTemp.push(item.id);

  const data = {
    presentQuestionsSelected: [item.id],
    absentQuestionsSelected: [],
    unknownQuestionsSelected: [],
  };
  state.questionWithAnswers.push(data);
}

export function addAbsentQuestion({ item, state, setState }) {
  state.orderIdArray.push(state.Questions.order);
  //before adding check if its there already, if its there remove old one
  var absentTemp = state.absentQuestionsSelectedTemp.indexOf(item.id);
  if (absentTemp > -1) {
    state.absentQuestionsSelectedTemp.splice(absentTemp, 1);
  }

  //check other options if this question is saved
  var presentTemp = state.presentQuestionsSelectedTemp.indexOf(item.id);
  if (presentTemp > -1) {
    state.presentQuestionsSelectedTemp.splice(presentTemp, 1);
  }

  var unKnownTemp = state.unknownQuestionsSelectedTemp.indexOf(item.id);
  if (unKnownTemp > -1) {
    state.unknownQuestionsSelectedTemp.splice(unKnownTemp, 1);
  }

  if (absentTemp === -1) {
    compareQuestionArrayAndReplace(state);
  }

  state.absentQuestionsSelected.push(item.id);
  state.absentQuestionsSelectedTemp.push(item.id);

  const data = {
    presentQuestionsSelected: [],
    absentQuestionsSelected: [item.id],
    unknownQuestionsSelected: [],
  };

  state.questionWithAnswers.push(data);
}

export function addUnknownQuestion({ item, state, setState }) {
  state.orderIdArray.push(state.Questions.order);
  //before adding check if its there already, if its there remove old one
  var unKnownTemp = state.unknownQuestionsSelectedTemp.indexOf(item.id);
  if (unKnownTemp > -1) {
    state.unknownQuestionsSelectedTemp.splice(unKnownTemp, 1);
  }

  //check other options if this question is saved
  var presentTemp = state.presentQuestionsSelectedTemp.indexOf(item.id);
  if (presentTemp > -1) {
    state.presentQuestionsSelectedTemp.splice(presentTemp, 1);
  }

  var absentTemp = state.absentQuestionsSelectedTemp.indexOf(item.id);
  if (absentTemp > -1) {
    state.absentQuestionsSelectedTemp.splice(absentTemp, 1);
  }

  if (unKnownTemp === -1) {
    compareQuestionArrayAndReplace(state);
  }

  state.unknownQuestionsSelected.push(item.id);
  state.unknownQuestionsSelectedTemp.push(item.id);

  const data = {
    presentQuestionsSelected: [],
    absentQuestionsSelected: [],
    unknownQuestionsSelected: [item.id],
  };

  state.questionWithAnswers.push(data);
}

export async function addPresentQuestionTemp({ dataId, state, setState }) {
  //before adding check if its there already, if its there remove old one
  var presentTemp = state.presentQuestionsSelectedTemp.indexOf(dataId);
  if (presentTemp > -1) {
    state.presentQuestionsSelectedTemp.splice(presentTemp, 1);
  }
  //check other options if this question is saved
  var absentTemp = state.absentQuestionsSelectedTemp.indexOf(dataId);
  if (absentTemp > -1) {
    state.absentQuestionsSelectedTemp.splice(absentTemp, 1);
  }

  var unKnownTemp = state.unknownQuestionsSelectedTemp.indexOf(dataId);
  if (unKnownTemp > -1) {
    state.unknownQuestionsSelectedTemp.splice(unKnownTemp, 1);
  }
  //if there is no values available previously
  if (presentTemp === -1) {
    compareQuestionArrayAndReplace(state);
  }
  state.presentQuestionsSelectedTemp.push(dataId);
}

export async function addAbsentQuestionTemp({ dataId, state, setState }) {
  //before adding check if its there already, if its there remove old one
  var presentTemp = state.presentQuestionsSelectedTemp.indexOf(dataId);
  if (presentTemp > -1) {
    state.presentQuestionsSelectedTemp.splice(presentTemp, 1);
  }
  //check other options if this question is saved
  var absentTemp = state.absentQuestionsSelectedTemp.indexOf(dataId);
  if (absentTemp > -1) {
    state.absentQuestionsSelectedTemp.splice(absentTemp, 1);
  }

  var unKnownTemp = state.unknownQuestionsSelectedTemp.indexOf(dataId);
  if (unKnownTemp > -1) {
    state.unknownQuestionsSelectedTemp.splice(unKnownTemp, 1);
  }
  //if there is no values available previously
  if (presentTemp === -1) {
    compareQuestionArrayAndReplace(state);
  }
  state.absentQuestionsSelectedTemp.push(dataId);
}


export function addUnknownQuestionTemp({ dataId, state, setState }) {
  //before adding check if its there already, if its there remove old one
  var unKnownTemp = state.unknownQuestionsSelectedTemp.indexOf(dataId);
  if (unKnownTemp > -1) {
    state.unknownQuestionsSelectedTemp.splice(unKnownTemp, 1);
  }

  //check other options if this question is saved
  var presentTemp = state.presentQuestionsSelectedTemp.indexOf(dataId);
  if (presentTemp > -1) {
    state.presentQuestionsSelectedTemp.splice(presentTemp, 1);
  }

  var absentTemp = state.absentQuestionsSelectedTemp.indexOf(dataId);
  if (absentTemp > -1) {
    state.absentQuestionsSelectedTemp.splice(absentTemp, 1);
  }

  //if there is no values available previously
  if (unKnownTemp === -1) {
    compareQuestionArrayAndReplace(state);
  }
  state.unknownQuestionsSelectedTemp.push(dataId);
}
